import { Box, Text } from '@domain-group/suit-theme'

import getFullAddress from '@functions/address'

import type { AgencyModel } from '@models/agency'

interface AgencyContactInfoProps {
  agency: AgencyModel,
  backgroundColor?: string,
}

const AgencyContactInfo = (props: AgencyContactInfoProps) => {
  const {
    agency: {
      address_line_1,
      address_line_2,
      address_region,
      phone,
      title,
      website,
    },
    backgroundColor,
  } = props

  const addressString = getFullAddress({
    address_line_1,
    address_line_2,
    address_region,
  }, { multiLine: false, localAddress: true })

  return (
    <Box
      alignItems="center"
      backgroundColor={backgroundColor || 'backgroundColor'}
      flexDirection="column"
      justifyContent="center"
      paddingY="xlarge"
      position="relative"
      zIndex="10"
    >
      <Box
        flexDirection="column"
        maxWidth={['100%', '900px']}
        paddingX="xlarge"
        margin="0 auto"
        justifyContent="center"
        alignItems="start"
      >
        <Text
          color="bodyFontColor"
          fontSize="xsmall"
          fontWeight="bold"
          marginBottom="medium"
        >
          {title}
        </Text>

        <Text
          color="bodyFontLightColor"
          fontSize="xsmall"
          marginBottom="medium"
        >
          {addressString}
        </Text>

        <Text
          color="bodyFontLightColor"
          fontSize="xsmall"
          marginBottom="medium"
        >
          {website}
        </Text>

        <Text
          color="bodyFontLightColor"
          fontSize="xsmall"
          marginBottom="medium"
        >
          {phone}
        </Text>
      </Box>
    </Box>
  )
}

export default AgencyContactInfo
